/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("COMMON", "199")




export interface API20887Req {
  
  /**  */
  projectId: string;
    
  /**  */
  ossFile: string;
    
  /** 过期时间，单位：小时 */
  expire?: string;
    
};



export interface API20887Res {
  /**   */
  url: string;
  
};


// 20887 使用签名URL临时授权

export interface IUseGetAPI20887Return {
  /** 使用签名URL临时授权: 接口请求状态 */
  isAPI20887Loading: boolean;
  /** 使用签名URL临时授权: 接口请求返回数据 */
  dataAPI20887: API20887Res;
  /**  使用签名URL临时授权: 接口数据请求方法 */
  fetchAPI20887Data:  (inputs: API20887Req, config?: YWRequestConfig) => Promise<API20887Res>;
  /** 使用签名URL临时授权: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI20887 = ():IUseGetAPI20887Return => {
  let isMount = true;
  const [isAPI20887Loading, setIsAPI20887Loading] = useState(false);
  const [dataAPI20887, setDataAPI20887] = useState<API20887Res>({} as API20887Res);
  const requestUrl = `${basePath}/ywwl-generic-base/oss/getGeneratePresignedUrl`;

  const fetchAPI20887Data = async (inputs: API20887Req, config?: YWRequestConfig): Promise<API20887Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API20887Req>) || {}) as API20887Req;
    
  
    if ( isMount ) {
      setIsAPI20887Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API20887Res>(`${basePath}/ywwl-generic-base/oss/getGeneratePresignedUrl?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI20887(res || {} as API20887Res);
        setIsAPI20887Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI20887Loading(false);
      }
      return false as unknown as API20887Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI20887Loading,
    dataAPI20887,
    fetchAPI20887Data,
    requestUrl,
  }
}

